<!-- 7. PREGUNTAS FRECUENTES (formato citable: pregunta como encabezado + respuesta directa) -->
<section class="faq-section" id="preguntas-frecuentes" aria-labelledby="faq-title">
  <div class="faq-container">

    <!-- Encabezado: mismo patrón que servicios (título + párrafo centrados) -->
    <header class="faq-head">
      <h2 class="section-title2" id="faq-title" appRevealOnScroll>Preguntas frecuentes</h2>
      <p class="faq-lead">
        Antes de tu primera sesión, resolvemos lo que más nos preguntan sobre la
        terapia online, los pagos y la confidencialidad.
      </p>
    </header>

    <!-- Acordeón accesible (patrón "disclosure"): la pregunta sigue siendo un <h3>
         y la respuesta permanece siempre en el DOM (solo se colapsa visualmente),
         por lo que el texto sigue siendo indexable y citable por buscadores y asistentes de IA.
         Coincide con el bloque FAQPage del JSON-LD de src/index.html. -->
    <div class="faq-list">
      <article
        class="faq-item"
        *ngFor="let faq of faqs; let i = index; trackBy: trackByQuestion"
        [class.is-open]="isOpen(i)">

        <h3 class="faq-question">
          <button
            type="button"
            class="faq-trigger"
            [id]="'faq-trigger-' + i"
            [attr.aria-expanded]="isOpen(i)"
            [attr.aria-controls]="'faq-panel-' + i"
            (click)="toggle(i)">
            <span class="faq-question-text">{{ faq.question }}</span>
            <span class="faq-toggle" aria-hidden="true"></span>
          </button>
        </h3>

        <div
          class="faq-panel"
          [id]="'faq-panel-' + i"
          role="region"
          [attr.aria-labelledby]="'faq-trigger-' + i">
          <div class="faq-panel-inner">
            <p class="faq-answer" [innerHTML]="faq.answer"></p>
          </div>
        </div>
      </article>
    </div>

    <!-- Cierre de la lista: lleva al formulario de contacto -->
    <p class="faq-footer">
      <a class="faq-more" href="#contacto">
        ¿Tienes otra pregunta? Escríbenos
        <i class="fas fa-arrow-right" aria-hidden="true"></i>
      </a>
    </p>

  </div>
</section>
